import Vue from "vue";

export const FALCONATIONME_CONFIG = {
    'IS_PROD': true,
    'API_PATH': 'https://api.falconation.me/',
    'HOMEPAGE': 'https://falconation.me/',
    'COOKIE_DOMAIN': '.falconation.me',
    'STRIPE': 'pk_test_7WxyNu2Ez44dmcDBKkiC62gh00CXaZUrMB',
    'SEGMENT_KEY': 'U7PDcvLsT6MBiCMg73BM5FZI7quT0X11',
    'INTEGRATIONS':[
        //sentry
        function(){
            Sentry.init({
                dsn: "https://7e8c03ae418949cfa45fd883b8ed0c30@o475019.ingest.sentry.io/5517246",
                integrations: [
                    new Sentry.Integrations.Vue({
                        Vue,
                        tracing: true,
                    }),
                    new Sentry.Integrations.BrowserTracing(),
                ],

                // We recommend adjusting this value in production, or using tracesSampler
                // for finer control
                tracesSampleRate: 1.0,
            });
        },
        function () {
            $("body").append('<script id="calendlyWidget" src="https://assets.calendly.com/assets/external/widget.js" type="text/javascript" async></script>');
        }
    ],
    INTERCOM_TOUR_ID: 224840,
    DEMO_REPORT_ID: 128,
}
